import { AdminFinanceWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AdminFinanceWebService.Configuration
});

export default config;
